import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import LoginView from "../views/LoginView.vue";
import WorkSpaceView from "../views/WorkSpaceView.vue";
import JoinWorkSpaceView from "../views/JoinWorkSpaceView.vue";
import ForgotPasswordSelfView from "../views/ForgotPasswordSelfView.vue";
import ResetPasswordView from "../views/ResetPasswordView.vue";
import PageNotFoundView from "../views/PageNotFoundView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/join",
    name: "joinworkspace",
    component: JoinWorkSpaceView,
    meta: { requiresAuth: false },
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { requiresAuth: false },
  },
  {
    path: "/forgot",
    name: "ForgotPasswordSelf",
    component: ForgotPasswordSelfView,
    meta: { requiresAuth: false },
  },
  {
    path: "/workspaces",
    name: "workspaces",
    component: WorkSpaceView,
    meta: { requiresAuth: true },
  },
  {
    path: "/resetPassword",
    name: "ResetPassword",
    component: ResetPasswordView,
    meta: { requiresAuth: false },
  },
  {
    path: "/:pathMatch(.*)*",
    component: PageNotFoundView,
  },
];

const router = new VueRouter({
  base: process.env.VUE_APP_publicPath,
  routes,
});

function afterEach() {
  store.dispatch("setLoading", false);
}

router.beforeEach((to, from, next) => {
  // instead of having to check every route record with
  // to.matched.some(record => record.meta.requiresAuth)
  store.dispatch("setLoading", true).then(() => {
    if (to.meta.requiresAuth && !store.getters["login/getAuthenticated"]) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      // return {
      //   path: "/login",
      //   // save the location we were at to come back later
      //   query: { redirect: to.fullPath },
      // };

      //This specific check is because router.afterEach is not called in the event that
      //the user gets redirected to the same place they are coming from
      if (from.name == "login") {
        afterEach();
      }
      next("/login");
      return;
    }
    next();
  });
});

router.afterEach(afterEach);

export default router;
